/* ─── Navbar scroll ──────────────────────────────────────────── */
(function () {
  const navbar = document.getElementById('navbar');
  if (!navbar) return;

  const onScroll = () => {
    navbar.classList.toggle('scrolled', window.scrollY > 40);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ─── Mobile nav ─────────────────────────────────────────────── */
(function () {
  const hamburger = document.getElementById('hamburger');
  const mobileNav = document.getElementById('mobileNav');
  if (!hamburger || !mobileNav) return;

  let open = false;

  window.closeMobileNav = function () {
    open = false;
    mobileNav.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  hamburger.addEventListener('click', () => {
    open = !open;
    mobileNav.classList.toggle('open', open);
    hamburger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && open) window.closeMobileNav();
  });
})();

/* ─── Scroll-triggered animations ───────────────────────────── */
(function () {
  const targets = document.querySelectorAll('.fade-up, .stagger-children');
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );

  targets.forEach((el) => observer.observe(el));
})();

/* ─── Counter animation ──────────────────────────────────────── */
(function () {
  const counters = document.querySelectorAll('[data-count]');
  if (!counters.length) return;

  const animate = (el) => {
    const target = parseInt(el.dataset.count, 10);
    const duration = 1400;
    const start = performance.now();

    const tick = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(eased * target);
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  counters.forEach((el) => observer.observe(el));
})();


/* ─── Request form ───────────────────────────────────────────── */
(function () {
  // Mismo criterio que ofrenda.js: si el landing se sirve en local, el
  // pre-registro debe llegar al backend local — si no, un registro de
  // prueba hecho en local termina en la base de producción y nunca
  // aparece en la bandeja de Super Admin que se está mirando (local).
  const isLocal = ['localhost', '127.0.0.1'].includes(location.hostname);
  const API_BASE = isLocal ? 'http://localhost:8080' : 'https://api.ekleria.pe';

  const form      = document.getElementById('requestForm');
  const success   = document.getElementById('formSuccess');
  const submitBtn = document.getElementById('formSubmit');
  if (!form) return;

  const showToast = (msg, duration = 3500) => {
    const toast   = document.getElementById('toast');
    const toastMsg = document.getElementById('toastMsg');
    if (!toast) return;
    toastMsg.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), duration);
  };

  const validate = (form) => {
    const required = form.querySelectorAll('[required]');
    for (const field of required) {
      if (field.type === 'checkbox') {
        if (!field.checked) {
          field.focus();
          showToast('Debes aceptar los términos y el sistema de sostenimiento para registrarte.');
          return false;
        }
        continue;
      }
      if (!field.value.trim()) {
        field.focus();
        showToast('Por favor completa todos los campos requeridos.');
        return false;
      }
      if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
        field.focus();
        showToast('Ingresa un correo electrónico válido.');
        return false;
      }
    }
    return true;
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!validate(form)) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Enviando...';

    try {
      const payload = {
        nombrePastor:        form.nombrePastor.value.trim(),
        telefono:            form.telefono.value.trim(),
        nombreIglesia:       form.nombreIglesia.value.trim(),
        email:               form.email.value.trim(),
        pais:                form.pais.value,
        tamano:              form.tamano.value,
        necesidad:           form.necesidad.value.trim(),
        aceptaTerminos:      form.aceptaTerminos.checked,
        aceptaSostenimiento: form.aceptaSostenimiento.checked,
      };

      const res = await fetch(API_BASE + '/api/request-entry/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      form.style.display = 'none';
      if (success) success.style.display = 'block';
      showToast('¡Registro enviado! Te contactaremos pronto.');
    } catch (err) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Enviar registro';
      showToast('Ocurrió un error al enviar. Por favor intenta de nuevo.');
    }
  });
})();

/* ─── Modal: términos y condiciones ──────────────────────────── */
(function () {
  const modal = document.getElementById('termsModal');
  if (!modal) return;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-terms]')) {
      e.preventDefault();
      modal.showModal();
    }
    if (e.target.closest('[data-close-terms]')) {
      modal.close();
    }
  });

  modal.addEventListener('click', (e) => {
    const r = modal.getBoundingClientRect();
    const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    if (!inside) modal.close();
  });
})();

/* ─── Smooth active nav link ─────────────────────────────────── */
(function () {
  const sections = document.querySelectorAll('section[id], div[id]');
  const navLinks = document.querySelectorAll('.navbar__links a');
  if (!sections.length || !navLinks.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          navLinks.forEach((link) => {
            const href = link.getAttribute('href');
            link.style.color = href === `#${entry.target.id}`
              ? 'var(--accent-primary)'
              : '';
          });
        }
      });
    },
    { threshold: 0.4 }
  );

  sections.forEach((s) => observer.observe(s));
})();
